import {pickBy, startsWith} from "lodash"

/**
 * Checks if the messages for the specified bucket have been loaded
 *
 * @param {Object} intl The intl object containing the messages
 * @param {String} bucket The bucket name to look for
 *
 * @return Boolean
 *
 */
export default (intl, bucket) => {
  return !!Object.keys(pickBy(intl.messages, (val, key) => startsWith(key, `${bucket.toLowerCase()}.`))).length
}
